// services/paymentGatewayStatus.ts — shared gateway readiness check (dipakai editor, order page, payment page)
// Root cause fix 2026-08-20: Midtrans "disable" di brand_settings tidak pernah dipakai untuk
// filter paymentMethods yang ditampilkan ke customer — checkout tetap render metode midtrans lama.
import { supabase } from '../supabase/client';
import { PAYMENT_OPTIONS } from '../pages/DigitalProductEditorPage/constants';

export interface GatewayStatus { midtrans: boolean; duitku: boolean; ipaymu: boolean }

const MEMO_TTL_MS = 60_000;
const memo = new Map<string, { at: number; value: GatewayStatus }>();

export const fetchGatewayStatus = async (brandId: string | undefined): Promise<GatewayStatus> => {
  if (!brandId) return { midtrans: false, duitku: false, ipaymu: false };
  const hit = memo.get(brandId);
  if (hit && Date.now() - hit.at < MEMO_TTL_MS) return hit.value;
  // RPC SECURITY DEFINER — anon tidak boleh baca brand_settings (RLS Admin-only),
  // tapi boleh tahu gateway mana yang aktif. Hanya boolean, tanpa apiKey.
  const { data, error } = await supabase.rpc('get_public_gateway_status', { p_brand_id: brandId });
  if (error || !data) return { midtrans: false, duitku: false, ipaymu: false };
  const d = data as any;
  const out = { midtrans: !!d.midtrans, duitku: !!d.duitku, ipaymu: !!d.ipaymu };
  memo.set(brandId, { at: Date.now(), value: out });
  return out;
};

const gatewayOf = (method: string): 'midtrans' | 'duitku' | 'ipaymu' =>
  PAYMENT_OPTIONS.find(o => o.value === method)?.gateway || 'midtrans';

/** Buang metode yang gateway-nya sudah dimatikan di brand_settings (serverKey/apiKey kosong). */
export const filterActiveMethods = (methods: string[], status: GatewayStatus): string[] =>
  methods.filter(m => status[gatewayOf(m)]);
